import { useQuery } from "react-query";

import { useCombinationRules } from "./useCombinationRules";
import { COMBINATION_RULES_QUERY_KEY } from "./useGetCombinationRules";

export const useGetRuleFilterPositions = () => {
  const { filterPositionsGet } = useCombinationRules();

  const { data, isLoading, isError } = useQuery({
    queryKey: [COMBINATION_RULES_QUERY_KEY, "filterPositions"],
    queryFn: () => filterPositionsGet(),
  });

  return {
    positions: data?.data,
    isLoading,
    isError,
  };
};
